import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchAuthenticated, API_BASE_URL } from "../utils/config";

function LineItemDetails() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const companyId = state?.companyId;
  const quickbooksItemId = state?.quickbooksItemId;
  const amount = state?.amount;
  const month = state?.month;

  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });

    if (!companyId || !quickbooksItemId || quickbooksItemId === -1) return;

    setLoading(true);

    fetchAuthenticated(`${API_BASE_URL}/quickbooks/getAccountItem`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        accountId: companyId,
        itemId: quickbooksItemId,
      }),
    })
      .then((r) => r?.json())
      .then((res) => {
        setItem(res?.data ?? null);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [companyId, quickbooksItemId]);

  // Render guard AFTER hooks
  if (!companyId || !quickbooksItemId || quickbooksItemId === -1) {
    return null;
  }

  if (loading) {
    return (
      <div className="loading-page">
        <div className="spinner" />
        <h2>Loading details...</h2>
      </div>
    );
  }

  return (
    <div className="page page--generate page--line-item">
      <div className="line-item-header">
        <button className="back-btn" onClick={() => navigate(-1)}>
          ← Back
        </button>

        <h1 className="line-item-title">
          {item?.name ?? "Line Item Details"}
        </h1>
      </div>

      <div className="card line-item-card">
        <div className="card-accent" />

        <div className="line-item-grid">
          <div className="line-item-row">
            <span className="label">Amount</span>
            <span className="value amount">
              ${Number(amount).toLocaleString("en-US", { minimumFractionDigits: 2 })}
            </span>
          </div>

          {month && (
            <div className="line-item-row">
              <span className="label">Month</span>
              <span className="value">{month}</span>
            </div>
          )}

          <div className="line-item-row">
            <span className="label">Type</span>
            <span className="value">{item?.type}</span>
          </div>

          <div className="line-item-row">
            <span className="label">Classification</span>
            <span className="value">{item?.classification}</span>
          </div>

          <div className="line-item-row">
            <span className="label">Currency</span>
            <span className="value">{item?.currency}</span>
          </div>

          <div className="line-item-row">
            <span className="label">Active</span>
            <span className={`value badge ${item?.active ? "yes" : "no"}`}>
              {item?.active ? "Active" : "Inactive"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LineItemDetails;
